module.exports = __webpack_public_path__ + "img/jomazad.ea396971.jpeg";